import { render, staticRenderFns } from "./homeLesson.vue?vue&type=template&id=967ee024&"
import script from "./homeLesson.vue?vue&type=script&lang=js&"
export * from "./homeLesson.vue?vue&type=script&lang=js&"
import style0 from "./homeLesson.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports